import { BaseStore } from "../../../react-core/Flux/BaseStore";
import { ActionType } from "../../../react-core/Flux/ActionType";
import { SingleDataStoreDispacher } from "./SingleDataStoreDispacher";

export interface ISingleDataStoreState<TPayload> {
    isLoading?: boolean;
    actionType: ActionType;
    data?: TPayload;
}

export class SingleDataStore<TPayload> extends BaseStore<ISingleDataStoreState<TPayload>> {
    public constructor(dispatcher: SingleDataStoreDispacher<TPayload>) {
        super();
        this.subscribeToDispatcher(dispatcher, (actionData) => this.onDispatching(actionData));
    }
    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData(): TPayload {
        return JSON.parse(JSON.stringify(this.getState().data));
    }    

    public getActionType() {
        return this.getState().actionType;
    }
    protected getDefaultState(): ISingleDataStoreState<TPayload> {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }
    private onDispatching(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;

            case ActionType.Update:
                this.setState({ actionType: ActionType.Update, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
